var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.404,
    height: 64.675,
    viewBox: "0 0 63.404 64.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chrome",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M31.707,0C14.2,0,0,14.472,0,32.332S14.2,64.67,31.707,64.67s31.7-14.479,31.7-32.337S49.216-.005,31.707-.005Z",
    transform: "translate(-0.005 0.004)",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1947",
    "data-name": "Group 1947",
    transform: "translate(15.218 15.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M23.057,27.976A8.2,8.2,0,0,1,18.47,26.62a8.626,8.626,0,0,1-3.1-3.487L8.589,11.25a16.827,16.827,0,0,0-2.065,8.265,15.911,15.911,0,0,0,4.037,10.817A16.162,16.162,0,0,0,20.6,35.854l4.8-8.3a7.642,7.642,0,0,1-2.342.421Z",
    transform: "translate(-6.524 -2.982)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M16.382,16.346a8.1,8.1,0,0,1,5.2-1.582H35.789a16.665,16.665,0,0,0-5.973-6.071,16.106,16.106,0,0,0-8.235-2.2,16.178,16.178,0,0,0-7.233,1.648,15.981,15.981,0,0,0-5.829,4.746l4.8,8.071a8.445,8.445,0,0,1,3.067-4.618Z",
    transform: "translate(-5.048 -6.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M31.233,12.437H21.627a8.822,8.822,0,0,1,2.777,6.2,8.447,8.447,0,0,1-1.486,4.844l-6.78,11.689A15.869,15.869,0,0,0,27.7,30.261a15.968,15.968,0,0,0,4.778-11.624A14.709,14.709,0,0,0,31.233,12.437Z",
    transform: "translate(0.59 -2.103)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_312",
    "data-name": "Ellipse 312",
    cx: 6.199,
    cy: 6.199,
    rx: 6.199,
    ry: 6.199,
    transform: "translate(10.333 10.334)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.52b661f4c2b16f9912d0123e668e192f.svg";
export { ForwardRef as ReactComponent };